<template>
    <o-table
        class="is-responsive is-responsive-xs-desktop"
        :data="paginatedData"
        :bordered="table.bordered"
        :striped="table.striped"
        :narrowed="table.narrowed"
        :checkable="table.checkable"
        :loading="table.loading"
        :mobile-cards="table.mobileCards"
        :per-page="table.perPage"
        :paginated="table.paginated"
        :pagination-simple="table.paginationSimple"
        default-sort="created_at"
        :selected.sync="selected"
        :checked-rows="checkedRows"
@update:checkedRows="$event => checkedRows = $event"
        backend-sorting
        backend-pagination

        @page-change="onPageChange"
        @sort="onSort"
        :total="total"
    >
        <template>
            <o-table-column #default="{ row }" field="created_at" label="Created At" sortable>
                {{ $filters.valueOrDefault($filters.date(row.created_at)) }}
            </o-table-column>

            <o-table-column #default="{ row }" field="id" label="Proposal #" sortable>
                {{ row.id }}
            </o-table-column>

            <o-table-column #default="{ row }" field="contact_id" label="Client" sortable>
                {{ contactNameById(row.contact_id) }}
            </o-table-column>

            <o-table-column #default="{ row }" field="address" label="Address" sortable>
                {{ row.address }}
            </o-table-column>

            <o-table-column #default="{ row }" field="borough" label="Borough" sortable>
                {{ boroughNameById(row.borough) }}
            </o-table-column>

            <o-table-column #default="{ row }" field="status" label="Status" sortable>
                {{ proposalStatusById(row.status) }}
            </o-table-column>

            <o-table-column #default="{ row }" label="">
                <o-dropdown hoverable position="bottom-left" class="table-actions">
                  <template #trigger>
                    <button class="button">
                      <o-icon pack="fa" icon="ellipsis-v"></o-icon>
                    </button>
                  </template>

                    <o-dropdown-item has-link>
                        <router-link :to="{ name: 'proposals.show', params: { slug: row.id } }">Edit</router-link>
                    </o-dropdown-item>
                </o-dropdown>
            </o-table-column>

        </template>

        <template #empty>
            <div class="has-text-centered">
                <p>No proposals found.</p>
            </div>
        </template>
    </o-table>
</template>

<script>
    import Table from '../../../mixins/Table'
    import { mapActions, mapGetters } from 'vuex'

    export default {
        mixins: [Table],

        props: ['userId'],

        data () {
            return {
                moment: window.moment,
                filters: {
                    created_by: this.userId
                }
            }
        },

        mounted () {
            this.fetchPaginatedData()
        },

        methods: {
            ...mapActions({
                fetchData: 'fetchProposals',
            }),
        },

        computed: {
            ...mapGetters(['proposals', 'contactNameById', 'boroughNameById', 'proposalStatusById']),

            ...mapGetters({
                itemsByIds: 'proposalsByIds'
            })
        }
    }
</script>
